import { isNonEmptyArray } from './types'

export const toArrayQueryParams = (array: Array<string | number>) => {
    if (isNonEmptyArray(array)) {
        return array.map((i) => i.toString()).join(',')
    }
    return undefined
}
